(function() {
  'use strict';

  angular
    .module('pub.posts.service', [])
    .factory('PostsService', PostsService);

  /** @ngInject */
  function PostsService($http, $q, API) {

    function listDraft(parentId, start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/unpublished?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function listPublished(parentId, start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/published?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function getId(parentId, id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(parentId, model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts', model)
          .success(defered.resolve);

        return defered.promise;
    }

    function update(parentId, id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id, model)
          .success(defered.resolve);

        return defered.promise;
    }

    function remove(parentId, id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function clone(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/posts/' + id + '/clone')
          .success(defered.resolve);

        return defered.promise;
    }

    function publish(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/posts/' + id + '/publish')
          .success(defered.resolve)
          .error(function(result){
            var html = result.error.message;
            html += "<br><br>";
            html += "<h3>Please check this items</h3>";
            html += '<ul style="text-align: left; font-size: 15px;"><li>Bundle is published</li><li>Publication date greater than today\'s date</li><li>Bundle not expired</li><li>Bundle not sold out</li></ul>';
            swal({
              title: html,
              text: "",
              html: true,
            });
          });

        return defered.promise;
    }

    function unpublish(id){
        var defered = $q.defer();

        $http.post(API.API_URL + 'publisher/posts/' + id + '/unpublish')
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function listPostSegmentation(parentId, id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id + '/user_segments')
        .success(defered.resolve);

      return defered.promise;
    }

    function listPostSegmentationUsers(parentId, id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id + '/user_segmenter_users')
        .success(defered.resolve);

      return defered.promise;
    }

    function listSegmentation(){
      var defered = $q.defer();

      $http.get(API.API_URL + 'publisher/user_segments')
        .success(defered.resolve);

      return defered.promise;
    }

    function addPostSegmentation(parentId, id, segmentId){
      var defered = $q.defer();

      $http.post(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removePostSegmentation(parentId, id, segmentId){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'publisher/channels/' + parentId + '/channel_posts/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve);

      return defered.promise;
    }

    function reorder(id, order){
      var defered = $q.defer();

      $http.put(API.API_URL + 'publisher/posts/' + id + '/order/' + order)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      listPublished: listPublished,
      listDraft: listDraft,
      getId: getId,
      save: save,
      update: update,
      remove: remove,
      clone: clone,
      publish: publish,
      unpublish: unpublish,
      listPostSegmentation: listPostSegmentation,
      listPostSegmentationUsers: listPostSegmentationUsers,
      listSegmentation: listSegmentation,
      addPostSegmentation: addPostSegmentation,
      removePostSegmentation: removePostSegmentation,
      reorder: reorder,
    };

  }

})();
